import { render, staticRenderFns } from "./VConnected.vue?vue&type=template&id=5b8713fc&"
import script from "./VConnected.vue?vue&type=script&lang=js&"
export * from "./VConnected.vue?vue&type=script&lang=js&"
import style0 from "./VConnected.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports